export const LOAD_PERIMETERS = 'LOAD_PERIMETERS'
export const LOAD_MAIN_PERIMETERS = 'LOAD_MAIN_PERIMETERS'
export const LOAD_USER_RIGHT = 'LOAD_USER_RIGHT'
export const LOAD_USER_DOOR_SONOTE = 'LOAD_USER_DOOR_SONOTE'